export default __webpack_public_path__ + "static/media/techc.cace3639.jpeg";